export class ImportTemplateDetailModel {
  id: number;
  columnNumber: number;
  columnName: string;
  questionText: string;
  questionType: string;
  choiceAnswer: string;
  parentId: number;
  importTemplateDetails: ImportTemplateDetailModel[];
  oldType: string;
  isNotValid: boolean;
}

export class ImportTemplate {
  id: number;
  clientId: number;
  templateName: string;
  userIds: number[];
  permission: number;
  importTemplateDetailModels: ImportTemplateDetailModel[];
}



// WEBPACK FOOTER //
// ./src/app/models/import-csv/import-template.model.ts